export default class Constants {
    static appid = 'wx084c57619586dcdf'
}